/* ==========================================================================
   BD Main Product — custom product page
   File: assets/bd-main-product.js
   ========================================================================== */

(function () {
  'use strict';

  document.querySelectorAll('[data-bd-pp-section]').forEach(function (section) {
    initGallery(section);
    initSizePicker(section);
    initAccordion(section);
    initSizeGuideModal(section);
  });

  initMarquees();

  /* ==========================================================
     Gallery — thumbnails + prev/next arrows
     ========================================================== */
  function initGallery(section) {
    var main = section.querySelector('[data-bd-gallery-main]');
    var thumbsWrap = section.querySelector('[data-bd-thumbs]');
    var prevBtn = section.querySelector('[data-bd-gallery-prev]');
    var nextBtn = section.querySelector('[data-bd-gallery-next]');
    if (!main) return;

    var slides = Array.from(main.querySelectorAll('[data-bd-slide]'));
    var thumbs = thumbsWrap ? Array.from(thumbsWrap.querySelectorAll('[data-bd-thumb]')) : [];
    var current = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(parseInt(t.dataset.index, 10));
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
  }

  /* ==========================================================
     Size picker — updates the hidden variant input AND the
     visible price (each size can have a different price, and
     the price block only renders server-side once at page load
     — without this, the price text stays frozen on the default
     variant's price no matter which size you click).
     ========================================================== */
  function initSizePicker(section) {
    var picker = section.querySelector('[data-bd-size-picker]');
    if (!picker) return;
    var input = section.querySelector('[data-bd-variant-input]');
    var priceEl = section.querySelector('[data-bd-price]');
    var comparePriceEl = section.querySelector('[data-bd-compare-price]');
    var saleBadgeEl = section.querySelector('[data-bd-sale-badge]');

    picker.querySelectorAll('.bd-pp-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-unavailable')) return;
        picker.querySelectorAll('.bd-pp-size-btn').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        if (input) input.value = btn.dataset.variantId;

        if (priceEl && btn.dataset.price) {
          priceEl.textContent = btn.dataset.price;
        }
        var hasSale = btn.dataset.hasSale === 'true';
        if (comparePriceEl) {
          if (hasSale) {
            comparePriceEl.textContent = btn.dataset.compareAtPrice;
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
        if (saleBadgeEl) {
          saleBadgeEl.style.display = hasSale ? '' : 'none';
        }
      });
    });
  }

  /* ==========================================================
     Accordion — first item open by default
     ========================================================== */
  function initAccordion(section) {
    var items = Array.from(section.querySelectorAll('[data-bd-acc-item]'));
    if (items.length === 0) return;

    items.forEach(function (item, index) {
      var trigger = item.querySelector('[data-bd-acc-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !wasOpen);
        trigger.setAttribute('aria-expanded', String(!wasOpen));
      });
      if (index === 0) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ==========================================================
     Size guide modal
     ========================================================== */
  function initSizeGuideModal(section) {
    var openBtn = section.querySelector('[data-bd-size-guide-open]');
    var modal = section.querySelector('[data-bd-size-modal]');
    if (!openBtn || !modal) return;

    var closeEls = modal.querySelectorAll('[data-bd-size-modal-close]');

    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ==========================================================
     Marquee swipe — real drag for any [data-bd-marquee]
     ========================================================== */
  function initMarquees() {
    var DURATION = 18; // seconds — must match the CSS animation duration

    document.querySelectorAll('[data-bd-marquee]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-bd-marquee-track]');
      if (!track) return;

      var startX = null, baseOffset = 0, dragging = false, resumeTimer = null, cycleWidth = 0;

      function getOffset() {
        var m = window.getComputedStyle(track).transform;
        if (m && m !== 'none') {
          var parts = m.match(/matrix.*\((.+)\)/);
          if (parts) return parseFloat(parts[1].split(', ')[4]) || 0;
        }
        return 0;
      }

      function measureCycleWidth() {
        cycleWidth = track.scrollWidth / 3;
      }

      function holdStill(x) {
        clearTimeout(resumeTimer);
        track.style.animation = 'none';
        track.style.transform = 'translateX(' + x + 'px)';
      }

      function scheduleResume(x) {
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          if (!cycleWidth) measureCycleWidth();
          var progress = ((-x) % cycleWidth) / cycleWidth;
          if (progress < 0) progress += 1;
          track.style.transform = '';
          track.style.animation = '';
          track.style.animationDelay = (-progress * DURATION) + 's';
        }, 2500);
      }

      function start(x) {
        dragging = true;
        startX = x;
        baseOffset = getOffset();
        holdStill(baseOffset);
        wrap.classList.add('is-dragging');
      }
      function move(x) {
        if (!dragging) return;
        track.style.transform = 'translateX(' + (baseOffset + (x - startX)) + 'px)';
      }
      function end(x) {
        if (!dragging) return;
        dragging = false;
        var finalOffset = baseOffset + (x - startX);
        wrap.classList.remove('is-dragging');
        holdStill(finalOffset);
        scheduleResume(finalOffset);
      }

      wrap.addEventListener('touchstart', function (e) { start(e.touches[0].clientX); }, { passive: true });
      wrap.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
      wrap.addEventListener('touchend', function (e) { end(e.changedTouches[0].clientX); });
      wrap.addEventListener('mousedown', function (e) { start(e.clientX); });
      window.addEventListener('mousemove', function (e) { move(e.clientX); });
      window.addEventListener('mouseup', function (e) { end(e.clientX); });

      // Touchpad two-finger horizontal swipe fires as 'wheel' events with
      // deltaX, not mouse/touch events — separate from click-drag above.
      // Only intercept when the gesture is more horizontal than vertical,
      // so normal page scrolling still passes through untouched.
      wrap.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        var nextOffset = getOffset() - e.deltaX;
        holdStill(nextOffset);
        scheduleResume(nextOffset);
      }, { passive: false });
    });
  }
})();